module.exports = __webpack_public_path__ + "img/2-users-20x20.f4c98b2c.svg";